<template>
	<a class="itv-card" :href="content.url" target="_blank">
		<div class="itv-card__wrapper">
			<div class="itv-card__header">
				<ul v-if="getLabels.length !== 0" class="itv-card__label-wrap">
					<li
						v-for="item in getLabels"
						:key="item.type"
						:class="`itv-card__label itv-card__label--${item.type}`"
					>
						{{ item.text }}
					</li>
				</ul>
				<div class="itv-card__date" v-html="content.date"></div>
			</div>
			<h3 class="itv-card__title" v-html="content.name"></h3>
		</div>
		<div class="itv-card__footer">
			<div class="itv-card__desc">
				<span v-if="content.props.city" v-html="content.props.city"></span>
				<br />
				<span
					v-if="content.props.company"
					v-html="content.props.company"
				></span>
			</div>
			<div class="itv-card__btn-wrap">
				<primary-button :content="button" @click-event="() => {}" />
			</div>
		</div>
	</a>
</template>

<script>
import PrimaryButton from '../ui/PrimaryButton'

export default {
	name: 'Card',
	components: {
		PrimaryButton,
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			button: {
				btnColorType: 'black',
				text: 'Подробнее',
			},
		}
	},
	methods: {
		createLabel(type, text) {
			return {
				type: type,
				text: text,
			}
		},
	},
	computed: {
		getLabels() {
			const { props } = this.content
			const labels = []
			if (props.biz === 'Y') labels.push(this.createLabel('biz', 'Бизнес'))
			if (props.it === 'Y') labels.push(this.createLabel('it', 'IT и digital'))
			if (props.intern === 'Y')
				labels.push(this.createLabel('intern', 'Стажировка'))

			return labels
		},
	},
}
</script>
